import {
  MatchingPaymentFinishedTicketsRequestParams,
  MatchingPayoutFinishedTicketsRequestParams,
  MatchingPaymentTicketListResponse,
  MatchingPayoutTicketListResponse,
} from './_models'
import { EFileStatus, EMatchingPaymentTicketStatus, EMatchingPayoutTicketStatus } from '../../../../types/enums'

// Генератор мок-тикетов пополнения
function generateMockPaymentTickets(count = 50) {
  const merchants = [
    { id: 'merchant-001', name: 'Мерчант 1' },
    { id: 'merchant-002', name: 'Мерчант 2' },
    { id: 'merchant-003', name: 'Мерчант 3' },
  ]
  const statuses = [
    EMatchingPaymentTicketStatus.WAITING_FOR_ACTION,
    EMatchingPaymentTicketStatus.NOT_CONFIRMED,
    EMatchingPaymentTicketStatus.PAYMENT_PENDING,
    EMatchingPaymentTicketStatus.WAITING_FOR_SMS,
    EMatchingPaymentTicketStatus.DECLINED,
    EMatchingPaymentTicketStatus.COMPLETED,
    EMatchingPaymentTicketStatus.EXPIRED,
  ]
  const tickets = []

  // Добавляем тикет со статусом EXPIRED
  tickets.push({
    ticketToken: '00000001-expired',
    merchantId: merchants[0].id,
    createdAt: new Date(Date.now() - 1000000).toISOString(),
    expectedAmount: 1500,
    amount: 0,
    merchant: merchants[0].name,
    clientId: 1,
    externalUserId: 'ext-1',
    paymentMethod: 'MC/VISA/MIR P2P RUB',
    completionDate: null,
    status: EMatchingPaymentTicketStatus.EXPIRED,
    requisite: {
      identifier: '1234 5678 9000 3456',
      bank: 'Сбербанк',
      cardholder: 'Иванов И.И.',
    },
    files: [],
  })
  // Добавляем тикет со статусом COMPLETED
  tickets.push({
    ticketToken: '00000002-completed',
    merchantId: merchants[1].id,
    createdAt: new Date(Date.now() - 2000000).toISOString(),
    expectedAmount: 2000,
    amount: 2000,
    merchant: merchants[1].name,
    clientId: 2,
    externalUserId: 'ext-2',
    paymentMethod: 'SBP P2P RUB',
    completionDate: new Date(Date.now() - 1000000).toISOString(),
    status: EMatchingPaymentTicketStatus.COMPLETED,
    requisite: {
      identifier: '+7 900 123-400',
      bank: 'Тинькофф',
      cardholder: 'Петров П.П.',
    },
    files: [],
  })

  for (let i = 0; i < count; i++) {
    const merchant = merchants[i % merchants.length]
    const status = statuses[i % statuses.length]
    const random = Math.random()

    const billStatus =
      random > 0.6
        ? EFileStatus.REJECTED
        : random > 0.8
          ? EFileStatus.VERIFIED
          : EFileStatus.PROCESSING

    const files = []

    if (random > 0.2) {
      files.push({
        id: i + random,
        url: `https://example.com/file${i + random}.jpg`,
        status: billStatus,
      })
      if (random > 0.8) {
        files.push({
          id: i + random + 1,
          url: `https://example.com/file${i + random + 1}.jpg`,
          status: billStatus,
        })
      }
    }

    const ticketToken = `${(i + 1).toString().padStart(8, '0')}-aaaa-bbbb-cccc-${(i + 1)
      .toString()
      .padStart(12, '0')}`
    tickets.push({
      ticketToken,
      merchantId: merchant.id,
      createdAt: new Date(Date.now() - i * 3600 * 1000).toISOString(),
      expectedAmount: 1000 + i * 10,
      amount: i % 3 === 0 ? 0 : 1000 + i * 10,
      merchant: merchant.name,
      clientId: (i % 5) + 1,
      externalUserId: `ext-${(i % 5) + 1}`,
      paymentMethod: i % 2 === 0 ? 'MC/VISA/MIR P2P RUB' : 'SBP P2P RUB',
      completionDate:
        status === EMatchingPaymentTicketStatus.COMPLETED
          ? new Date(Date.now() - i * 1800 * 1000).toISOString()
          : null,
      status,
      // CPAYMENT-1712: каждый третий — без исполнителя, проверяем прочерк в колонке.
      executor: i % 3 === 0 ? null : `operator${(i % 5) + 1}`,
      requisite: {
        identifier:
          i % 2 === 0
            ? `1234 5678 90${i.toString().padStart(2, '0')} 3456`
            : `+7 900 123-4${i.toString().padStart(2, '0')}`,
        bank: i % 2 === 0 ? 'Сбербанк' : 'Тинькофф',
        cardholder: i % 2 === 0 ? 'Иванов И.И.' : 'Петров П.П.',
      },
      files: files,
    })
  }
  return tickets
}

// Генератор мок-тикетов выплат
function generateMockPayoutTickets(count = 50) {
  const merchants = [
    { id: 'merchant-001', name: 'Мерчант 1' },
    { id: 'merchant-002', name: 'Мерчант 2' },
    { id: 'merchant-003', name: 'Мерчант 3' },
  ]
  const statuses = [
    EMatchingPayoutTicketStatus.COMPLETED,
    EMatchingPayoutTicketStatus.DECLINED,
    EMatchingPayoutTicketStatus.ACTIVE,
    EMatchingPayoutTicketStatus.PLACEMENT_PENDING,
  ]
  const tickets = []
  for (let i = 0; i < count; i++) {
    const merchant = merchants[i % merchants.length]
    const status = statuses[i % statuses.length]
    const ticketToken = `${(i + 1).toString().padStart(8, '0')}-pppp-qqqq-rrrr-${(i + 1)
      .toString()
      .padStart(12, '0')}`
    tickets.push({
      ticketToken,
      merchantId: merchant.id,
      merchant: merchant.name,
      createdAt: new Date(Date.now() - i * 7200 * 1000).toISOString(),
      completionDate:
        status === EMatchingPayoutTicketStatus.COMPLETED
          ? new Date(Date.now() - i * 3600 * 1000).toISOString()
          : null,
      matchCount: (i % 4) + 1,
      matchingRemainder: (i % 3) * 100,
      paymentMethod: i % 2 === 0 ? 'MC/VISA/MIR P2P RUB' : 'SBP P2P RUB',
      expectedAmount: 2000 + i * 20,
      amount: i % 2 === 0 ? 2000 + i * 20 : 0,
      clientId: (i % 5) + 1,
      externalUserId: `ext-${(i % 5) + 1}`,
      // Каждый пятый — без токена клиента: проверяем показ id текстом, без битой ссылки.
      clientToken: i % 5 === 0 ? null : `00000000-0000-5000-8000-${(i + 1).toString().padStart(12, '0')}`,
      status,
      paymentTicketList: [
        {
          ticketToken: `pt-${(i + 1).toString().padStart(8, '0')}`,
          merchantId: merchant.id,
          createdAt: new Date(Date.now() - i * 7200 * 1000).toISOString(),
          expectedAmount: 1000 + i * 10,
          amount: 1000 + i * 10,
          completionDate: null,
          clientId: (i % 5) + 1,
          externalUserId: `ext-${(i % 5) + 1}`,
          merchant: merchant.name,
          status: EMatchingPaymentTicketStatus.EXPIRED,
          authorId: 10,
          approximateAmount: 1000 + i * 10,
          files: [
            {
              id: i + 1,
              url: `https://example.com/file${i + 1}.jpg`,
              status: EFileStatus.VERIFIED,
            },
          ],
        },
      ],
    })
  }
  return tickets
}

const MOCK_PAYMENT_TICKETS = generateMockPaymentTickets(50)
const MOCK_PAYOUT_TICKETS = generateMockPayoutTickets(50)

function filterPaymentTickets(
  tickets: typeof MOCK_PAYMENT_TICKETS,
  params: Partial<MatchingPaymentFinishedTicketsRequestParams>
) {
  let filtered = [...tickets]
  if (params.search) {
    filtered = filtered.filter((t) => t.ticketToken.includes(params.search!))
  }
  if (params.merchantTokenList && params.merchantTokenList.length > 0) {
    filtered = filtered.filter((t) => params.merchantTokenList!.includes(t.merchantId!))
  }
  if (params.statusList && params.statusList.length > 0) {
    filtered = filtered.filter((t) => params.statusList!.includes(t.status as any))
  }
  return filtered
}

function filterPayoutTickets(
  tickets: typeof MOCK_PAYOUT_TICKETS,
  params: Partial<MatchingPayoutFinishedTicketsRequestParams>
) {
  let filtered = [...tickets]
  if (params.search) {
    filtered = filtered.filter((t) => t.ticketToken.includes(params.search!))
  }
  if (params.statusList && params.statusList.length > 0) {
    filtered = filtered.filter((t) => params.statusList!.includes(t.status as any))
  }
  return filtered
}

export function mockGetMatchingPaymentTickets(
  params: Partial<MatchingPaymentFinishedTicketsRequestParams>
) {
  const page = params.page || 1
  const perPage = params.perPage || 10
  const filtered = filterPaymentTickets(MOCK_PAYMENT_TICKETS, params)
  const paginated = filtered.slice((page - 1) * perPage, page * perPage)
  const res: MatchingPaymentTicketListResponse = {
    success: true,
    totalRows: filtered.length,
    list: paginated,
  }
  return Promise.resolve({ data: res })
}

export function mockGetMatchingPayoutTickets(params: Partial<MatchingPayoutFinishedTicketsRequestParams>) {
  const page = params.page || 1
  const perPage = params.perPage || 10
  const filtered = filterPayoutTickets(MOCK_PAYOUT_TICKETS, params)
  const paginated = filtered.slice((page - 1) * perPage, page * perPage)
  const res: MatchingPayoutTicketListResponse = {
    success: true,
    totalRows: filtered.length,
    list: paginated,
  }
  return Promise.resolve({ data: res })
}

export function mockVerifyMatchingPaymentBill(id: string) {
  return Promise.resolve({ data: '', status: 200, statusText: 'OK' })
}

export function mockRejectMatchingPaymentBill(id: string) {
  return Promise.resolve({ data: '', status: 200, statusText: 'OK' })
}

export function mockFinishMatchingPayoutTicket(token: string, body: object = {}) {
  return Promise.resolve({ data: { success: true, message: 'Выплата завершена' } })
}

export function mockHaltMatchingPayoutTicket(token: string, body: object = {}) {
  return Promise.resolve({ data: { success: true, message: 'Выплата отменена' } })
}

export function mockDeclineMatchingPayoutTicket(token: string) {
  const ticket = MOCK_PAYMENT_TICKETS.find((t) => t.ticketToken === token)
  if (ticket) {
    ticket.status = EMatchingPaymentTicketStatus.EXPIRED
    return Promise.resolve({ data: { success: true, ticket }, status: 200, statusText: 'OK' })
  }
  return Promise.resolve({ data: { success: false, message: 'Тикет не найден' }, status: 404, statusText: 'Not Found' })
}

export function mockFinishMatchingPaymentTicket(token: string, amount?: number) {
  // Находим тикет по токену и меняем статус и сумму
  const ticket = MOCK_PAYMENT_TICKETS.find((t) => t.ticketToken === token)
  if (ticket) {
    ticket.status = EMatchingPaymentTicketStatus.COMPLETED
    ticket.amount = amount ?? ticket.amount
    ticket.completionDate = new Date().toISOString()
    return Promise.resolve({ data: { success: true, ticket }, status: 200, statusText: 'OK' })
  }
  return Promise.resolve({ data: { success: false, message: 'Тикет не найден' }, status: 404, statusText: 'Not Found' })
}

export function mockGetMerchantList() {
  return Promise.resolve({
    data: {
      success: true,
      totalRows: 6,
      merchants: [
        {
          operators: [
            {
              id: 16,
              uuid: 'operator_championdx_1',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-06-25T08:41:30+00:00',
            },
            {
              id: 71,
              uuid: 'operator_vocxod',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2024-04-16T14:02:35+00:00',
            },
            {
              id: 72,
              uuid: 'senior_operator_vocxod',
              roles: ['ROLE_USER', 'ROLE_OPERATOR', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2024-04-16T14:02:36+00:00',
            },
          ],
          platform: {
            id: 70,
            uuid: 'chc_platform',
            roles: ['ROLE_USER', 'ROLE_PLATFORM'],
            enabled: true,
            createdAt: '2024-04-16T14:02:34+00:00',
            callbackUrl: 'https://test.chcplatform.net/api/payment/pay_update',
          },
          token: 'a5e0d0d7-2ea3-5e7a-9e4d-206bc12d46ca',
          title: 'Vocxod',
          enabled: true,
          allowAnonymousPayments: true,
          userPageHost: null,
          createdAt: '2024-04-16T14:02:34+00:00',
        },
        {
          operators: [
            {
              id: 16,
              uuid: 'operator_championdx_1',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-06-25T08:41:30+00:00',
            },
            {
              id: 12,
              uuid: 'operator_chc_manual_2',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-05-27T10:06:29+00:00',
            },
            {
              id: 13,
              uuid: 'senior_operator_chc_manual_2',
              roles: ['ROLE_USER', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2023-05-03T18:51:09+00:00',
            },
            {
              id: 20,
              uuid: 'senior_operator_championdx_1',
              roles: ['ROLE_USER', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2023-06-25T08:55:04+00:00',
            },
          ],
          platform: {
            id: 2,
            uuid: 'platform',
            roles: ['ROLE_USER', 'ROLE_PLATFORM'],
            enabled: true,
            createdAt: '2023-04-08T17:07:38+00:00',
            callbackUrl: 'https://test.chcadmin.net/api/payment/pay_update',
          },
          token: '79cb8e04-50d3-59e1-9a94-5831c5cd0166',
          title: 'сhcmanual',
          enabled: true,
          allowAnonymousPayments: true,
          userPageHost: null,
          createdAt: '2023-05-05T14:13:45+00:00',
        },
        {
          operators: [
            {
              id: 31,
              uuid: 'operator_vovan',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-09-02T13:25:58+00:00',
            },
            {
              id: 32,
              uuid: 'senior_operator_vovan',
              roles: ['ROLE_USER', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2023-09-02T13:27:36+00:00',
            },
          ],
          platform: {
            id: 22,
            uuid: 'sgratortech',
            roles: ['ROLE_USER', 'ROLE_PLATFORM'],
            enabled: true,
            createdAt: '2023-08-08T17:19:12+00:00',
            callbackUrl: 'https://example.com',
          },
          token: '12ca3e12-27c1-59e1-9a91-2618a3fe1496',
          title: 'vovan',
          enabled: true,
          allowAnonymousPayments: true,
          userPageHost: null,
          createdAt: '2023-08-08T17:25:00+00:00',
        },
        {
          operators: [
            {
              id: 63,
              uuid: 'operator_lion',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-12-20T14:18:04+00:00',
            },
            {
              id: 64,
              uuid: 'senior_operator_lion',
              roles: ['ROLE_USER', 'ROLE_OPERATOR', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2023-12-20T14:18:05+00:00',
            },
          ],
          platform: {
            id: 62,
            uuid: 'winwin',
            roles: ['ROLE_USER', 'ROLE_PLATFORM'],
            enabled: true,
            createdAt: '2023-12-20T14:18:02+00:00',
            callbackUrl: 'https://example.com',
          },
          token: '1619ce26-33ea-50b6-91ee-3ed4f73d1984',
          title: 'lion',
          enabled: true,
          allowAnonymousPayments: true,
          userPageHost: null,
          createdAt: '2023-12-20T14:18:02+00:00',
        },
        {
          operators: [
            {
              id: 16,
              uuid: 'operator_championdx_1',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-06-25T08:41:30+00:00',
            },
            {
              id: 20,
              uuid: 'senior_operator_championdx_1',
              roles: ['ROLE_USER', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2023-06-25T08:55:04+00:00',
            },
          ],
          platform: {
            id: 2,
            uuid: 'platform',
            roles: ['ROLE_USER', 'ROLE_PLATFORM'],
            enabled: true,
            createdAt: '2023-04-08T17:07:38+00:00',
            callbackUrl: 'https://test.chcadmin.net/api/payment/pay_update',
          },
          token: 'a3fa3d81-17d5-59e1-9a91-56a8f3ae1d96',
          title: 'championdx',
          enabled: true,
          allowAnonymousPayments: false,
          userPageHost: null,
          createdAt: '2023-09-04T11:53:02+00:00',
        },
        {
          operators: [
            {
              id: 9,
              uuid: 'senior_operator_betrun_1',
              roles: ['ROLE_USER', 'ROLE_SENIOR_OPERATOR'],
              enabled: true,
              createdAt: '2023-05-03T18:51:09+00:00',
            },
            {
              id: 5,
              uuid: 'operator_betrun_1',
              roles: ['ROLE_USER', 'ROLE_OPERATOR'],
              enabled: true,
              createdAt: '2023-05-03T18:51:09+00:00',
            },
          ],
          platform: {
            id: 2,
            uuid: 'platform',
            roles: ['ROLE_USER', 'ROLE_PLATFORM'],
            enabled: true,
            createdAt: '2023-04-08T17:07:38+00:00',
            callbackUrl: 'https://test.chcadmin.net/api/payment/pay_update',
          },
          token: '99cb8e04-47d3-59e1-9a91-5731c5ce0467',
          title: 'betrun',
          enabled: true,
          allowAnonymousPayments: true,
          userPageHost: null,
          createdAt: '2023-06-01T12:29:29+00:00',
        },
      ],
    },
  })
}

export function getTicketActionErrorMessage(response: any) {
  if (response?.status === 422) return 'Этот тикет нельзя изменить'
  if (response?.data?.errors?.general_error) return response?.data?.errors?.general_error
  if (response instanceof Error && response?.message) return response.message
  return 'Неизвестная ошибка'
}


export function mockChangeExpectedAmountMatchingPaymentTicket(token: string, amount: number) {
  // Находим тикет по токену и меняем сумму
  const ticket = MOCK_PAYMENT_TICKETS.find((t) => t.ticketToken === token)
  if (ticket) {
    ticket.expectedAmount = amount
    return Promise.resolve({ data: { success: true, ticket }, status: 200, statusText: 'OK' })
  }
  return Promise.resolve({ data: { success: false, message: 'Тикет не найден' }, status: 404, statusText: 'Not Found' })
}
